import React, { lazy } from "react";
import { Navigate } from "react-router-dom";

/* Android */
const AndroidList = lazy(() => import("./Android/List"));
const AndroidDetail = lazy(() => import("./Android/Detail"));
const AndroidUpload = lazy(() => import("./Android/Upload"));

/* IOS */
const IOSList = lazy(() => import("./IOS/List"));
const IOSDetail = lazy(() => import("./IOS/Detail"));
const IOSUpload = lazy(() => import("./IOS/Upload"));
// const IOSSelectFile = lazy(() => import("../routes/IOS/SelectFile"));
// const IOSProtectRecord = lazy(() => import("../routes/IOS/ProtectRecord"));

/* H5 */
const H5List = lazy(() => import("./H5/List"));
const H5Detail = lazy(() => import("./H5/Detail"));
const H5Upload = lazy(() => import("./H5/Upload"));
// const H5MiniUpload = lazy(() => import("../routes/H5/MiniAPPUpload"));
// const H5ProtectRecord = lazy(() => import("../routes/H5/ProtectRecord"));
// const H5WebviewProtect = lazy(() => import("../routes/H5/WebviewProtect"));
// const WebviewFile = lazy(() => import("../routes/Webview/File"));

const ScanWebRouter = [
    {
        key: "android-root",
        path: "android",
        title: "Android Application Hardening",
        hide: false,
        children: [
            {
                key: "android-redirect",
                index: true,
                element: <Navigate to="list" replace />, // ✅ 改为相对路径
                hide: true,
            },
            {
                key: "android-list",
                path: "list",
                element: <AndroidList />,
                hide: true, // ✅ 只有 list 可见（菜单逻辑里控制）
            },
            {
                key: "android-detail",
                path: "detail",
                element: <AndroidDetail />,
                hide: true,
            },
            {
                key: "android-apkupload",
                path: "upload",
                element: <AndroidUpload />,
                hide: true,
            },
        ],
    },
    {
        key: "ios-root",
        path: "ios",
        title: "iOS Application Hardening",
        hide: false,
        children: [
            {
                key: "ios-redirect",
                index: true,
                element: <Navigate to="list" replace />, // ✅ 修正
                hide: true,
            },
            {
                key: "ios-list",
                path: "list",
                element: <IOSList />,
                hide: true, // ✅ 只有 list 可见
            },
            {
                key: "ios-detail",
                path: "detail",
                element: <IOSDetail />,
                hide: true,
            },
            {
                key: "ios-upload",
                path: "upload",
                element: <IOSUpload />,
                hide: true,
            },
            // {
            //     key: "ios-selectFile",
            //     path: "selectFile",
            //     element: <IOSSelectFile />,
            //     hide: true,
            // },
            // {
            //     key: "ios-protect-record",
            //     path: "protect-record",
            //     element: <IOSProtectRecord />,
            //     hide: true,
            // },
        ],
    },

    {
        key: "h5-root",
        path: "h5",
        title: "H5 Hardening",
        hide: false,
        children: [
            {
                key: "h5-redirect",
                index: true,
                element: <Navigate to="list" replace />, // ❗ 原来写错成 android/list，已修正
                hide: true,
            },
            {
                key: "h5-list",
                path: "list",
                element: <H5List />,
                hide: true, // ✅ 只有 list 可见
            },
            {
                key: "h5-detail",
                path: "detail",
                element: <H5Detail />,
                hide: true,
            },
            {
                key: "h5-upload",
                path: "upload",
                element: <H5Upload />,
                hide: true,
            },
            // {
            //     key: "h5-appupload",
            //     path: "appupload",
            //     element: <H5MiniUpload />,
            //     hide: true,
            // },
            // {
            //     key: "h5-protect-record",
            //     path: "protect-record",
            //     element: <H5ProtectRecord />,
            //     hide: true,
            // },
            // {
            //     key: "h5-protectRecord",
            //     path: "protectRecord",
            //     element: <H5WebviewProtect />,
            //     hide: true,
            // },
            // {
            //     key: "h5-uploadfile",
            //     path: "uploadfile",
            //     element: <WebviewFile />,
            //     hide: true,
            // },
        ],
    },
];
export default ScanWebRouter;
